import { ca } from '@cian/analytics';

export const trackClickOffer = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Click',
    action: 'to_card',
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
